import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Product detail collapsible sections — one-click hide, one-click show.
 * Each section toggles independently. Pass `defaultOpen` to auto-open on mount.
 */
export function AccordionItem({ title, defaultOpen = false, testid, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-sj-ink/10" data-testid={testid}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full flex items-center justify-between py-4 text-left group"
        data-testid={`${testid}-toggle`}
      >
        <span className="text-[13px] tracking-[0.18em] uppercase font-semibold text-sj-ink group-hover:text-sj-goldDark transition-colors">
          {title}
        </span>
        <ChevronDown
          size={18}
          className={`text-sj-inkSoft transition-transform duration-300 ${open ? "rotate-180" : "rotate-0"}`}
        />
      </button>
      <div
        className={`grid transition-all duration-300 ease-out ${open ? "grid-rows-[1fr] opacity-100 pb-5" : "grid-rows-[0fr] opacity-0"}`}
        data-testid={`${testid}-body`}
      >
        <div className="overflow-hidden">
          <div className="text-sm text-sj-inkSoft leading-relaxed">{children}</div>
        </div>
      </div>
    </div>
  );
}
